<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center">
      <h3>积分管理</h3>
    </div>

    <el-form :inline="!UI.isMobile" :label-position="UI.isMobile ? 'top' : 'right'" size="mini" :model="filterForm">
      <el-form-item label="赛季">
        <el-select v-model="filterForm.season" placeholder="请选择赛季" @change="handleSeasonChange">
          <el-option v-for="(item, index) in seasons" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSeasonChange()">
          查询
        </el-button>
      </el-form-item>
    </el-form>

    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane label="积分排名" name="ranking">
        <el-form :inline="!UI.isMobile" :label-position="UI.isMobile ? 'top' : 'right'" size="mini" :model="rankingForm">
          <el-form-item label="项目">
            <el-select clearable v-model="rankingForm.item" placeholder="请选择">
              <el-option v-for="item in itemOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组别">
            <el-select clearable v-model="rankingForm.group" placeholder="请选择">
              <el-option v-for="item in groupOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="flushRanking()">
              查询
            </el-button>
            <el-button @click="rankingForm = { item: '', group: '' }; flushRanking();">
              重置
            </el-button>
            <el-button type="success" @click="handleExportRanking()">
              导出
            </el-button>
          </el-form-item>
        </el-form>

        <el-table :data="rankingTableData" style="width: 100%" border>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div style="margin-left: 47px; margin-right: 180px">
                <el-table :data="props.row.items" border size="mini">
                  <el-table-column prop="item" label="项目"></el-table-column>
                  <el-table-column prop="group" label="组别"></el-table-column>
                  <el-table-column prop="points" label="积分"></el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="rank" label="排名" width="80"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="identifier_code" label="证件号码"></el-table-column>
          <el-table-column label="性别" width="70">
            <template slot-scope="scope">
              {{ scope.row.sex == 1 ? '女' : '男' }}
            </template>
          </el-table-column>
          <el-table-column prop="org" label="单位"></el-table-column>
          <el-table-column prop="item" label="项目"></el-table-column>
          <el-table-column prop="group" label="组别"></el-table-column>
          <el-table-column prop="points" label="积分"></el-table-column>
        </el-table>

        <div class="flex justify-center align-center full-width margin-top">
          <el-pagination :hide-on-single-page="rankingTotal <= rankingForm.page_size"
            @current-change="handleRankingCurrentChange" :current-page.sync="rankingForm.page"
            :page-size="rankingForm.page_size" layout="total, prev, pager, next, jumper" :total="rankingTotal">
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="赛季赛事" name="games">
        <div class="flex justify-between align-center margin-bottom">
          <span>当前赛季({{ filterForm.season }})包含的赛事</span>
          <el-button type="primary" size="small" @click="showAddGameSeason">
            添加赛事到赛季
          </el-button>
        </div>

        <el-table :data="gamesTableData" style="width: 100%" border>
          <el-table-column prop="title" label="赛事标题"></el-table-column>
          <el-table-column prop="org" label="主办单位"></el-table-column>
          <el-table-column prop="game_start_time" label="比赛时间"></el-table-column>
          <el-table-column label="所属赛季">
            <template slot-scope="scope">
              {{ scope.row.season }}
              <el-tag size="mini" :type="scope.row.season_source == 'manual' ? 'warning' : 'info'">
                {{ scope.row.season_source == 'manual' ? '手动' : '自动' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="260">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.exclude_from_points" active-text="不计积分"
                @change="handleToggleExclude(scope.row)">
              </el-switch>
              <el-button type="primary" size="small" @click="showSetSeason(scope.row)" class="margin-left">
                设置赛季
              </el-button>
              <el-button v-if="scope.row.season_source == 'manual'" type="danger" size="small"
                @click="handleClearGameSeason(scope.row.id)">
                恢复自动
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex justify-center align-center full-width margin-top">
          <el-pagination :hide-on-single-page="gamesTotal <= gamesForm.page_size" @current-change="handleGamesCurrentChange"
            :current-page.sync="gamesForm.page" :page-size="gamesForm.page_size"
            layout="total, prev, pager, next, jumper" :total="gamesTotal">
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="积分调整" name="adjustments">
        <div class="flex justify-between align-center margin-bottom">
          <span>手动为运动员增加/减少积分</span>
          <div>
            <el-button size="small" @click="showImportGuide">导入说明</el-button>
            <el-upload action="#" :before-upload="handleImportExcel" :show-file-list="false" accept=".xlsx,.xls"
              style="display: inline-block; margin-left: 10px">
              <el-button type="success" size="small">批量导入</el-button>
            </el-upload>
            <el-button type="primary" size="small" @click="showAddAdjustment" style="margin-left: 10px">
              添加调整
            </el-button>
          </div>
        </div>

        <el-table :data="adjustmentsTableData" style="width: 100%" border>
          <el-table-column type="index" label="序号" width="60" :index="indexMethod"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="identifier_code" label="证件号码"></el-table-column>
          <el-table-column prop="season" label="赛季"></el-table-column>
          <el-table-column prop="item" label="项目"></el-table-column>
          <el-table-column prop="group" label="组别"></el-table-column>
          <el-table-column prop="points" label="积分"></el-table-column>
          <el-table-column prop="note" label="备注"></el-table-column>
          <el-table-column prop="c_time" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleDeleteAdjustment(scope.row.id)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex justify-center align-center full-width margin-top">
          <el-pagination :hide-on-single-page="adjustmentsTotal <= adjustmentsForm.page_size"
            @current-change="handleAdjustmentsCurrentChange" :current-page.sync="adjustmentsForm.page"
            :page-size="adjustmentsForm.page_size" layout="total, prev, pager, next, jumper"
            :total="adjustmentsTotal">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="设置赛季" :visible.sync="setSeasonShow" show-close width="420px" :fullscreen="UI.isMobile">
      <el-form :model="setSeasonInfo" label-width="90px">
        <el-form-item label="赛事">
          <el-input :value="setSeasonInfo.title" disabled></el-input>
        </el-form-item>
        <el-form-item label="赛季">
          <el-select v-model="setSeasonInfo.season" placeholder="请选择赛季">
            <el-option v-for="(item, index) in seasons" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="flex justify-center align-center">
        <el-button class="login-button padding-xs margin-top" type="primary" size="mini" @click="handleSetGameSeason()">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加赛事到赛季" :visible.sync="addGameSeasonShow" show-close width="520px" :fullscreen="UI.isMobile">
      <el-form :model="addGameSeasonInfo" label-width="90px">
        <el-form-item label="搜索赛事">
          <el-select v-model="addGameSeasonInfo.game_id" filterable remote :remote-method="searchGames"
            placeholder="输入赛事标题搜索" style="width: 100%">
            <el-option v-for="(item, index) in searchGameOptions" :key="index" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赛季">
          <el-select v-model="addGameSeasonInfo.season" placeholder="请选择赛季">
            <el-option v-for="(item, index) in seasons" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="flex justify-center align-center">
        <el-button class="login-button padding-xs margin-top" type="primary" size="mini" @click="handleAddGameSeason()">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加积分调整" :visible.sync="addAdjustmentShow" show-close width="520px" :fullscreen="UI.isMobile">
      <el-form :model="adjustmentInfo" label-width="90px">
        <el-form-item label="运动员">
          <el-select v-model="adjustmentInfo.user_info_id" filterable remote :remote-method="searchPlayers"
            placeholder="输入姓名搜索" style="width: 100%">
            <el-option v-for="(item, index) in searchPlayerOptions" :key="index" :label="`${item.name}(${item.identifier_code})`"
              :value="item.user_info_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赛季">
          <el-select v-model="adjustmentInfo.season" placeholder="请选择赛季">
            <el-option v-for="(item, index) in seasons" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目">
          <el-select clearable v-model="adjustmentInfo.item" placeholder="请选择">
            <el-option v-for="item in itemOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组别">
          <el-select clearable v-model="adjustmentInfo.group" placeholder="请选择">
            <el-option v-for="item in groupOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="积分">
          <el-input-number v-model="adjustmentInfo.points" :step="1" step-strictly></el-input-number>
          <span class="margin-left">负数为减分</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input clearable v-model="adjustmentInfo.note" placeholder="如:某比赛未在系统内"></el-input>
        </el-form-item>
      </el-form>
      <div class="flex justify-center align-center">
        <el-button class="login-button padding-xs margin-top" type="primary" size="mini" @click="handleAddAdjustment()">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入说明" :visible.sync="importGuideShow" show-close width="480px" :fullscreen="UI.isMobile">
      <div style="font-size: 13px; line-height: 1.8; color: #666">
        <p><b>Excel模板列说明：</b></p>
        <p>1. 证件号码（必填）- 用于匹配系统内运动员</p>
        <p>2. 项目 - 如：个人越野、短距离等</p>
        <p>3. 组别 - 如：男子组、女子组等</p>
        <p>4. 积分（必填）- 正数为加分，负数为减分</p>
        <p>5. 备注</p>
        <p style="margin-top: 10px; color: #999">赛季自动使用当前筛选的赛季（{{ filterForm.season }}）</p>
      </div>
      <div slot="footer">
        <el-button type="primary" size="small" @click="downloadImportTemplate">下载导入模板</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPointsSeasons,
  getPointsGames,
  setGameSeason,
  clearGameSeason,
  toggleExcludeFromPoints,
  getPointsRanking,
  getPointsAdjustments,
  addPointsAdjustment,
  batchAddPointsAdjustments,
  lookupPointsUsers,
  deletePointsAdjustment,
  getGamesList,
  getUserInfoList,
} from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import XLSX from 'xlsx';

export default {
  data() {
    return {
      activeTab: 'ranking',
      seasons: [],
      filterForm: {
        season: '',
      },
      rankingForm: {
        page: 1,
        page_size: 10,
        item: '',
        group: '',
      },
      rankingTableData: [],
      rankingTotal: 0,
      gamesForm: {
        page: 1,
        page_size: 10,
      },
      gamesTableData: [],
      gamesTotal: 0,
      adjustmentsForm: {
        page: 1,
        page_size: 10,
      },
      adjustmentsTableData: [],
      adjustmentsTotal: 0,
      setSeasonShow: false,
      setSeasonInfo: {},
      addGameSeasonShow: false,
      addGameSeasonInfo: {},
      searchGameOptions: [],
      addAdjustmentShow: false,
      adjustmentInfo: {
        user_info_id: '',
        season: '',
        item: '',
        group: '',
        points: 0,
        note: '',
      },
      searchPlayerOptions: [],
      importGuideShow: false,
      itemOptions: ['个人越野', '垂直竞速', '短距离', '混合接力', '团体'],
      groupOptions: [
        '男子组', '女子组', '混合组', '公开混合组', '团体组',
        'U14男子', 'U14女子', 'U16男子', 'U16女子',
        '大众男子组', '大众女子组',
      ],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.getSeasons();
  },

  methods: {
    getSeasons: function () {
      let that = this;
      getPointsSeasons(function (res) {
        that.seasons = res;
        if (!that.filterForm.season && res.length) {
          that.filterForm.season = res[0];
        }
        that.flushRanking();
      });
    },

    handleSeasonChange: function () {
      this.flushRanking();
      this.flushGames();
      this.flushAdjustments();
    },

    handleTabClick: function () {
      if (this.activeTab == 'ranking') {
        this.flushRanking();
      } else if (this.activeTab == 'games') {
        this.flushGames();
      } else if (this.activeTab == 'adjustments') {
        this.flushAdjustments();
      }
    },

    flushRanking: function () {
      if (!this.filterForm.season) return;
      let that = this;
      this.rankingForm.page = 1;
      getPointsRanking(
        Object.assign({}, this.rankingForm, { season: this.filterForm.season }),
        function (res) {
          that.rankingTableData = res.items;
          that.rankingTotal = res.total;
        }
      );
    },

    handleRankingCurrentChange: function () {
      let that = this;
      getPointsRanking(
        Object.assign({}, this.rankingForm, { season: this.filterForm.season }),
        function (res) {
          that.rankingTableData = res.items;
          that.rankingTotal = res.total;
        }
      );
    },

    handleExportRanking: function () {
      let that = this;
      getPointsRanking(
        Object.assign({}, this.rankingForm, {
          season: this.filterForm.season,
          page: 1,
          page_size: 100000,
        }),
        function (res) {
          const rows = res.items.map((item) => ({
            排名: item.rank,
            姓名: item.name,
            证件号码: item.identifier_code,
            性别: item.sex == 1 ? '女' : '男',
            单位: item.org,
            项目: item.item,
            组别: item.group,
            积分: item.points,
          }));
          const sheet = XLSX.utils.json_to_sheet(rows);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, sheet, '积分排名');
          const filter = [that.rankingForm.item, that.rankingForm.group].filter(Boolean).join('-') || '总积分';
          XLSX.writeFile(wb, `积分排名-${that.filterForm.season}-${filter}.xlsx`);
        }
      );
    },

    flushGames: function () {
      if (!this.filterForm.season) return;
      let that = this;
      this.gamesForm.page = 1;
      getPointsGames(
        Object.assign({}, this.gamesForm, { season: this.filterForm.season }),
        function (res) {
          that.gamesTableData = res.items;
          that.gamesTotal = res.total;
        }
      );
    },

    handleGamesCurrentChange: function () {
      let that = this;
      getPointsGames(
        Object.assign({}, this.gamesForm, { season: this.filterForm.season }),
        function (res) {
          that.gamesTableData = res.items;
          that.gamesTotal = res.total;
        }
      );
    },

    indexMethod: function (index) {
      return (this.adjustmentsForm.page - 1) * this.adjustmentsForm.page_size + index + 1;
    },

    flushAdjustments: function () {
      if (!this.filterForm.season) return;
      let that = this;
      this.adjustmentsForm.page = 1;
      getPointsAdjustments(
        Object.assign({}, this.adjustmentsForm, { season: this.filterForm.season }),
        function (res) {
          that.adjustmentsTableData = res.items;
          that.adjustmentsTotal = res.total;
        }
      );
    },

    handleAdjustmentsCurrentChange: function () {
      let that = this;
      getPointsAdjustments(
        Object.assign({}, this.adjustmentsForm, { season: this.filterForm.season }),
        function (res) {
          that.adjustmentsTableData = res.items;
          that.adjustmentsTotal = res.total;
        }
      );
    },

    showSetSeason: function (row) {
      this.setSeasonInfo = {
        id: row.id,
        title: row.title,
        season: row.season,
      };
      this.setSeasonShow = true;
    },

    handleSetGameSeason: function () {
      let that = this;
      if (!this.setSeasonInfo.season) {
        this.$message({ type: 'warning', message: '请选择赛季' });
        return;
      }
      setGameSeason(
        { game_id: this.setSeasonInfo.id, season: this.setSeasonInfo.season },
        function (res) {
          showSuccessMsg(res);
          that.setSeasonShow = false;
          that.flushGames();
        }
      );
    },

    handleClearGameSeason: function (gameId) {
      let that = this;
      this.$confirm('恢复为按比赛日期自动计算赛季?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          clearGameSeason(gameId, function (res) {
            showSuccessMsg(res);
            that.flushGames();
          });
        })
        .catch(() => {});
    },

    handleToggleExclude: function (row) {
      let that = this;
      toggleExcludeFromPoints(
        { game_id: row.id, exclude: row.exclude_from_points },
        function (res) {
          showSuccessMsg(res);
          that.flushGames();
        }
      );
    },

    searchGames: function (query) {
      let that = this;
      getGamesList(
        { page: 1, page_size: 20, title: query },
        function (res) {
          that.searchGameOptions = res.items;
        }
      );
    },

    showAddGameSeason: function () {
      this.addGameSeasonInfo = {
        game_id: '',
        season: this.filterForm.season,
      };
      this.searchGameOptions = [];
      this.addGameSeasonShow = true;
    },

    handleAddGameSeason: function () {
      let that = this;
      if (!this.addGameSeasonInfo.game_id || !this.addGameSeasonInfo.season) {
        this.$message({ type: 'warning', message: '请选择赛事和赛季' });
        return;
      }
      setGameSeason(
        { game_id: this.addGameSeasonInfo.game_id, season: this.addGameSeasonInfo.season },
        function (res) {
          showSuccessMsg(res);
          that.addGameSeasonShow = false;
          that.flushGames();
        }
      );
    },

    searchPlayers: function (query) {
      let that = this;
      getUserInfoList(
        { page: 1, page_size: 20, name: query, is_approved: 1 },
        function (res) {
          that.searchPlayerOptions = res.items;
        },
        undefined,
        undefined,
        { noLoading: true }
      );
    },

    showAddAdjustment: function () {
      this.adjustmentInfo = {
        user_info_id: '',
        season: this.filterForm.season,
        item: '',
        group: '',
        points: 0,
        note: '',
      };
      this.searchPlayerOptions = [];
      this.addAdjustmentShow = true;
    },

    handleAddAdjustment: function () {
      let that = this;
      if (!this.adjustmentInfo.user_info_id || !this.adjustmentInfo.season) {
        this.$message({ type: 'warning', message: '请选择运动员和赛季' });
        return;
      }
      addPointsAdjustment(this.adjustmentInfo, function (res) {
        showSuccessMsg(res);
        that.addAdjustmentShow = false;
        that.flushAdjustments();
      });
    },

    handleDeleteAdjustment: function (adjustmentId) {
      let that = this;
      this.$confirm('确认删除该积分调整记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deletePointsAdjustment(adjustmentId, function (res) {
            showSuccessMsg(res);
            that.flushAdjustments();
          });
        })
        .catch(() => {});
    },

    showImportGuide: function () {
      this.importGuideShow = true;
    },

    downloadImportTemplate: function () {
      const rows = [
        { '证件号码': '110101199001011234', '项目': '个人越野', '组别': '男子组', '积分': 10, '备注': '示例数据' },
      ];
      const sheet = XLSX.utils.json_to_sheet(rows);
      sheet['!cols'] = [
        { wch: 20 }, { wch: 12 }, { wch: 10 }, { wch: 8 }, { wch: 16 },
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, '积分调整导入模板');
      XLSX.writeFile(wb, '积分调整导入模板.xlsx');
    },

    handleImportExcel: function (file) {
      let that = this;
      if (!this.filterForm.season) {
        this.$message({ type: 'warning', message: '请先选择赛季' });
        return false;
      }
      const reader = new FileReader();
      reader.onload = function (e) {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet);

          if (!jsonData.length) {
            that.$message({ type: 'warning', message: 'Excel文件为空' });
            return;
          }

          const items = jsonData.map(row => ({
            identifier_code: row['证件号码'] || '',
            item: row['项目'] || '',
            group: row['组别'] || '',
            points: row['积分'] || 0,
            note: row['备注'] || '',
          }));

          const codes = [...new Set(items.map(i => i.identifier_code).filter(Boolean))];
          lookupPointsUsers({ codes: codes }, function (nameMap) {
            const preview = items.map((item, idx) => {
              const name = nameMap[item.identifier_code] || '未找到';
              const sign = item.points > 0 ? '+' : '';
              return (idx + 1) + '. ' + name + '（' + item.identifier_code + '） ' + sign + item.points + '分'
                + (item.item ? ' ' + item.item : '') + (item.group ? '/' + item.group : '');
            }).join('\n');

            that.$confirm(
              preview + '\n\n确认导入' + items.length + '条积分调整记录?',
              '导入预览',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
                center: true,
                dangerouslyUseHTMLString: false,
              }
            )
              .then(() => {
                batchAddPointsAdjustments(
                  { season: that.filterForm.season, items: items },
                  function (res) {
                    showSuccessMsg(res);
                    that.flushAdjustments();
                  }
                );
              })
              .catch(() => {});
          });
        } catch (err) {
          that.$message({ type: 'error', message: '文件解析失败，请检查文件格式' });
        }
      };
      reader.readAsArrayBuffer(file);
      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/games/points.vue